import { render, staticRenderFns } from "./FeaturesSplit.vue?vue&type=template&id=deb1192e&scoped=true&"
import script from "./FeaturesSplit.vue?vue&type=script&lang=js&"
export * from "./FeaturesSplit.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesSplit.vue?vue&type=style&index=0&id=deb1192e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb1192e",
  null
  
)

export default component.exports